var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ArticleLayout',{staticClass:"terms-conditions-container",attrs:{"title":"TERMS & CONDITIONS"}},[_c('iframe',{attrs:{"src":"/pdfjs/web/viewer.html?file=/terms-conditions.pdf"}})])}
var staticRenderFns = []

export { render, staticRenderFns }